import { render, staticRenderFns } from "./new-post-detail.vue?vue&type=template&id=20bdca94&scoped=true&"
import script from "./new-post-detail.vue?vue&type=script&lang=js&"
export * from "./new-post-detail.vue?vue&type=script&lang=js&"
import style0 from "./new-post-detail.vue?vue&type=style&index=0&id=20bdca94&lang=scss&scoped=true&"
import style1 from "./new-post-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bdca94",
  null
  
)

export default component.exports